import React from 'react';
import { FadeIn } from './FadeIn';
export function Bonuses() {
  const bonuses = [{
    num: 'B1',
    title: 'Mapa de Inicio Hybrid 360',
    desc: 'Empezá el método con claridad total en menos de 15 minutos. Mini test de perfil, ruta de lectura recomendada según tu nivel y objetivo, 7 pasos de activación y checklist de inicio. Sin confusión desde el día uno.'
  }, {
    num: 'B2',
    title: 'Checklist Pre-Entreno del Atleta Híbrido',
    desc: 'Entrá a cada entrenamiento con foco, estructura y propósito. Versión para fuerza, cardio e híbrido. Ritual de activación de 2 minutos. Nunca más entrés en modo caos.'
  }, {
    num: 'B3',
    title: 'Menú Express del Atleta Híbrido',
    desc: '15 desayunos, 15 almuerzos y 10 snacks estratégicos para no improvisar tus comidas. Fórmula base del plato híbrido y ajuste nutricional según el tipo de día de entrenamiento.'
  }, {
    num: 'B4',
    title: 'Diario Semanal de Progreso Hybrid 360',
    desc: 'Medí lo que importa y convertí tu progreso en algo visible. Registro de sesiones, seguimiento de recuperación, métricas semanales, revisión guiada y página de victoria semanal.'
  }, {
    num: 'B5',
    title: 'Reset Híbrido de 7 Días',
    desc: 'Recuperá foco, orden y estructura en solo 7 días sin empezar de cero. Plan día por día, 4 reglas del reset, tracker de hábitos y protocolo de transición al método completo.'
  }];
  return <section className="py-20 sm:py-32 px-4 bg-carbon-950 border-t border-carbon-800 blueprint-grid relative" data-id="element-15">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-16">
        <FadeIn data-id="element-17">
          <div className="flex items-center gap-4 mb-12" data-id="element-18">
            <span className="font-display text-4xl text-carbon-800" data-id="element-19">04</span>
            <div className="h-px bg-carbon-800 flex-grow" data-id="element-20" />
            <span className="font-mono text-xs text-carbon-400 uppercase tracking-widest" data-id="element-21">
              Los Bonos
            </span>
          </div>

          <div className="mb-16 max-w-3xl" data-id="element-22">
            <div className="inline-block border border-electric text-electric font-mono text-xs uppercase tracking-widest px-3 py-1 mb-6 bg-electric/5 rounded-full" data-id="element-23">
              5 Bonos Incluidos
            </div>
            <h2 className="text-4xl sm:text-5xl font-display text-white uppercase tracking-wide leading-[1.1]" data-id="element-24">
              Además de los 6 tomos, recibís 5 bonos diseñados para que
              arranques, sostengas y aceleres el sistema.
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-25">
          {bonuses.map((bonus, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-26">
              <div className="bg-carbon-900 border border-carbon-800 rounded-3xl p-8 h-full group hover:bg-carbon-950 transition-colors flex flex-col relative overflow-hidden" data-id="element-27">
                <div className="absolute top-0 left-0 w-1 h-full bg-carbon-800 group-hover:bg-electric transition-colors" data-id="element-28" />
                <span className="font-mono text-carbon-400 group-hover:text-electric transition-colors text-sm tracking-widest mb-4 block" data-id="element-29">
                  {bonus.num}
                </span>
                <h3 className="text-xl font-display text-white mb-3 uppercase tracking-wide" data-id="element-30">
                  {bonus.title}
                </h3>
                <p className="text-carbon-400 font-sans leading-relaxed text-sm flex-grow" data-id="element-31">
                  {bonus.desc}
                </p>
              </div>
            </FadeIn>)}
          <div className="hidden lg:block bg-carbon-950 rounded-3xl border border-carbon-800" data-id="element-32" />
        </div>
      </div>
    </section>;
}